export default __webpack_public_path__ + "static/BestBuy-5d8f3a8586e271e43169dd54608ebef6.png";